import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * 2026-10-24: login / signup calls (phone code, api-token-auth/) must not
 * carry the previous session's token. A leftover Authorization header used to
 * make the server attach the typed number to THAT account. AppInterceptor
 * neither adds a Bearer header nor tries a refresh for these requests.
 */
export const SKIP_AUTH = new HttpContextToken<boolean>(() => false);

export function withoutAuth(context: HttpContext = new HttpContext()): HttpContext {
  return context.set(SKIP_AUTH, true);
}
